var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info && _vm.info.t)?_c('div',{style:({ color: _vm.info.c })},[_vm._v(" "+_vm._s(_vm.info.t)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }